/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-lines */
/* eslint-disable max-len */
import ResetIcon from '@scandipwa/scandipwa/src/component/ResetIcon';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import CartIcon from 'Component/CartIcon';
import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM } from 'Component/ChevronIcon/ChevronIcon.config';
import FIELD_TYPE from 'Component/Field/Field.config';
import Loader from 'Component/Loader';
import Popup from 'Component/Popup';
import ReloadIcon from 'Component/ReloadIcon';
import SearchIcon from 'Component/SearchIcon';
import { CountryType, HreflangsType, StoreCountriesType } from 'Type/Stores.type';

import {
    TOUCH_TIMEOUT
} from './StoreSelector.config';

import './StoreSelector.style';

/** @namespace Bodypwa/Component/StoreSelector/Component */
export class StoreSelectorComponent extends PureComponent {
    static propTypes = {
        device: PropTypes.shape({
            isMobile: PropTypes.bool.isRequired
        }).isRequired,
        toggleStoreSelectPopup: PropTypes.func.isRequired,
        searchValue: PropTypes.string.isRequired,
        countries: PropTypes.arrayOf(StoreCountriesType).isRequired,
        onSearchChange: PropTypes.func.isRequired,
        selectCountry: PropTypes.func.isRequired,
        selectedCountry: CountryType.isRequired,
        redirectCountry: CountryType.isRequired,
        goToShop: PropTypes.func.isRequired,
        fitScreen: PropTypes.func.isRequired,
        isFitScreen: PropTypes.bool.isRequired,
        resetSearch: PropTypes.func.isRequired,
        setActive: PropTypes.func.isRequired,
        searchRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
        headerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
        isSimple: PropTypes.bool.isRequired,
        storeSelectorId: PropTypes.string.isRequired,
        popUpHeight: PropTypes.number.isRequired,
        disableScrolling: PropTypes.func.isRequired,
        enableScrolling: PropTypes.func.isRequired,
        hreflangs: HreflangsType.isRequired,
        statusCode: PropTypes.string.isRequired,
        isNoHreflangs: PropTypes.bool.isRequired,
        resetCountrySelect: PropTypes.func.isRequired,
        storeCountries: PropTypes.arrayOf(StoreCountriesType).isRequired,
        customLabel: PropTypes.string
    };

    static defaultProps = {
        customLabel: ''
    };

    renderFlag(code) {
        if (!code) {
            return null;
        }

        return (
          <span className={ `fi fi-${code?.toLowerCase()}` }>
            <span className="fi-border" />
            <span className="fi-borderGray" />
          </span>
        );
    }

    renderName() {
        const { selectedCountry: { label }, storeCountries, isSimple } = this.props;

        if (!label) {
            return (
              <span
                block="StoreSelector"
                elem="Placeholder"
              >
                { __('Select shipping country') }
              </span>
            );
        }

        return (
          <span className="StoreSelector-Name">
            { storeCountries.length > 1 && isSimple ? 'World Wide' : label }
          </span>
        );
    }

    goToShop = () => {
        const {
            goToShop, selectedCountry
        } = this.props;

        goToShop(selectedCountry);
    };

    redirectToShop = () => {
        const {
            goToShop, redirectCountry
        } = this.props;

        goToShop(redirectCountry, true);
    };

    renderStoreSelectButton = () => {
        const {
            goToShop, isSimple, hreflangs = [], statusCode, isNoHreflangs, selectedCountry
        } = this.props;

        if (isSimple) {
            return null;
        }

        if (hreflangs?.length === 0 && statusCode !== '404' && !isNoHreflangs) {
            return (
            <button
              block="Button"
              mix={ { block: 'StoreSelector', elem: 'Button' } }
              mods={ { isHollow: false } }
            >
              <span>
                <Loader isLoading isButton />
              </span>
            </button>
            );
        }

        return (
          <button
            block="Button"
            mix={ { block: 'StoreSelector', elem: 'Button' } }
            mods={ { isHollow: false } }
            // eslint-disable-next-line react/jsx-no-bind
            onClick={ () => goToShop(selectedCountry) }
          >
            <span>
              <CartIcon isActive={ false } isTransparent />
              { __('Go to shop') }
            </span>
          </button>
        );
    };

    onStoreItemClick = (item) => {
        const { selectCountry, isSimple } = this.props;
        selectCountry(item, isSimple);
    };

    onChange = (e) => {
        const { onSearchChange } = this.props;
        onSearchChange(e);
    };

    onFocus = () => {
        const { fitScreen, setActive, disableScrolling } = this.props;
        // This is required since the behavior trigers the click on the background
        setTimeout(() => {
            setActive();
            fitScreen();
            disableScrolling();
        }, TOUCH_TIMEOUT);
    };

    onBlur = () => {
        const {
            fitScreen, searchValue, setActive, enableScrolling
        } = this.props;

        setTimeout(() => {
            if (!searchValue) {
                fitScreen(false);
            }
            setActive(false);
            enableScrolling();
        }, TOUCH_TIMEOUT);
    };

     renderContent = () => {
         const {
             isFitScreen, storeSelectorId, popUpHeight, headerRef, resetCountrySelect
         } = this.props;

         return (
             <div block="StoreSelector" elem="Container">
                { this.renderStoreSelect() }
                <Popup
                  popUpHeight={ popUpHeight }
                  isHideHeader={ isFitScreen }
                  id={ storeSelectorId }
                  headerRef={ headerRef }
                  onClose={ resetCountrySelect }
                  mix={ { block: 'StoreSelector', mods: { isFitScreen } } }
                >
                    { this.renderStoreSelectSearch() }
                    <div block="StoreSelector" elem="MainContent">
                      { this.renderStoreSelectContent() }
                    </div>
                </Popup>
             </div>
         );
     };

     renderStoreSelectSearch = () => {
         const { searchValue, searchRef, isFitScreen } = this.props;
         return (
           <div
             block="StoreSelector"
             mods={ { isFitScreen } }
             elem="Search"
           >
               <SearchIcon />
               <input
                 type={ FIELD_TYPE.text }
                 onChange={ this.onChange }
                 onFocus={ this.onFocus }
                 onBlur={ this.onBlur }
                 placeholder={ __('Search for your country') }
                 value={ searchValue }
                 ref={ searchRef }
                 attr={ {
                     id: 'storeSearch',
                     name: 'storeSearch',
                     placeholder: __('Search'),
                     'aria-label': __('Search')
                 } }
               />
              { this.searchResetButton() }
           </div>
         );
     };

     renderStoreSelectContent = () => {
         const { countries = [], searchValue } = this.props;
         const noCountries = countries.filter((country) => country.names.filter((name) => name?.toLowerCase().includes(searchValue.toLowerCase())).length);

         if (!noCountries.length) {
             return this.renderNoResults();
         }

         return (
            <div block="StoreSelector" elem="List">
                { countries.map(this.renderStoreSelectOption) }
            </div>
         );
     };

     renderStoreSelectOption = (item) => {
         const { searchValue } = this.props;
         const {
             code, label, names, currency
         } = item;
         const searchParam = names.filter((name) => name?.toLowerCase().includes(searchValue.toLowerCase()));
         if (searchValue.trim() === '' || searchParam.length) {
             return (
                  <button
                    block="StoreSelector"
                    elem="Item"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={ () => this.onStoreItemClick(item) }
                  >
                      <div block="StoreSelector" elem="ItemInner">
                        <span className={ `fi fi-${code?.toLowerCase()}` }>
                          <span className="fi-border" />
                          <span className="fi-borderGray" />
                        </span>
                        <span
                          block="StoreSelector"
                          elem="Label"
                        >
                        { label }
                        </span>
                        <span
                          block="StoreSelector"
                          elem="Currency"
                        >
                        { currency }
                        </span>
                      </div>
                  </button>
             );
         }

         return null;
     };

     renderNoResults = () => (
        <div
          block="StoreSelector"
          elem="NoResults"
        >
          <div
            block="StoreSelector"
            elem="NoResultsContent"
          >
            { __('Nothing matches your search. Please check for misspellings or typos.') }
          </div>
          { this.renderResetButton() }
        </div>
     );

     resetSearch = () => {
         const { resetSearch } = this.props;
         // This is required since the behavior trigers the click on the background and closes the modal
         setTimeout(() => {
             resetSearch();
         }, TOUCH_TIMEOUT);
     };

     renderStoreSelect = () => {
         const {
             toggleStoreSelectPopup, isSimple, hreflangs = [], countries = [], statusCode, isNoHreflangs, selectedCountry: { code }, storeCountries, customLabel
         } = this.props;
         const block = isSimple ? ' ' : 'Button';
         const isDisabled = ((hreflangs !== null && hreflangs.length === 0 && statusCode !== '404') || countries.length === 0) && !isNoHreflangs;

         if (customLabel) {
             return (
              <button
                block="Link"
                onClick={ toggleStoreSelectPopup }
              >
                { customLabel }
              </button>
             );
         }

         return (
            <div block="StoreSelector" elem="Content" mods={ { isSimple, isDefault: !isSimple } }>
                <button
                  block={ block }
                  mix={ { block: 'StoreSelector', elem: 'Select', mods: { isSimple, isDefault: !isSimple, isDisabled } } }
                  disabled={ isDisabled }
                  mods={ { isHollow: false } }
                  onClick={ toggleStoreSelectPopup }
                >
                      { this.renderFlag(storeCountries.length > 1 && isSimple ? 'com' : code) }
                      { this.renderName() }
                      <ChevronIcon direction={ BOTTOM } />
                </button>
                { this.renderStoreSelectButton() }
            </div>
         );
     };

      renderResetButton = () => (
            <button
              block="StoreSelector"
              elem="Reset"
              onClick={ this.resetSearch }
            >
                <ReloadIcon />
                <span>
                  { __('Reset search') }
                </span>
            </button>
      );

     searchResetButton = () => {
         const {
             device: {
                 isMobile
             },
             isFitScreen,
             searchValue
         } = this.props;

         if ((isMobile && isFitScreen) || (!isMobile && searchValue)) {
             return (
             <button
               block="ResetIcon"
               onClick={ this.resetSearch }
             >
                <ResetIcon />
             </button>
             );
         }

         return null;
     };

     render() {
         const { isSimple } = this.props;
         return (
            <div block="StoreSelector" mods={ { isSimple, isDefault: !isSimple } }>
                { this.renderContent() }
            </div>
         );
     }
}

export default StoreSelectorComponent;
